import React from "react";
import {
    Box,
    Button,
    Flex,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Select,
    Text,
} from "components-lib";
import {handlePrescriptionCreation, prepareConsultationData} from "../../../../../services/prescriptionService";
import PreviewPageWYSIWYG from "./PreviewPageWYSIWYG";

/**
 * ConsultationModals Component
 *
 * Contains all modal dialogs used in the patient consultation flow:
 * - End consultation confirmation modal
 * - Online consultation modal
 * - Preview/print modal
 */
const ConsultationModals = ({
                                patientData,
                                patientActions,
                                patient,
                                doctor,
                                onBack,
                                handleSubmit//parameters
                            }) => {

    // Handle consultation end confirmation
    const handleConfirmEndConsultation = async () => {
        try {
            // Fetch parameters data from API for consultation
            // let consultationparametersData = {};
            // try {
            //     // const parametersResponse = await axiosInstance.get(`api/parameters/byAppointment?appointment_id=${patient.appointment_id || patient.id}`);
            //     if (parametersResponse.data) {
            //         consultationparametersData = parametersResponse.data;
            //     }
            // } catch (parametersError) {
            //     console.warn('Could not fetch parameters for consultation:', parametersError);
            // }
            // // If API parameters are empty, use parameters from textInputsData as fallback
            // if (Object.keys(consultationparametersData).length === 0 && textInputsData.parameters) {
            //     console.log('🔥 Debug - Using parameters from textInputsData as fallback:', textInputsData.parameters);
            //     consultationparametersData = textInputsData.parameters;
            // }
            //
            // console.log('🔥 Debug - Final consultationparametersData:', consultationparametersData);

            // Get text inputs data from localStorage for fallback
            const textInputsData = JSON.parse(localStorage.getItem('textInputsData') || '{}');


            handleSubmit() // Save Parameters before ending consultation


            console.log('🔥 Debug - Patient Data:', {
                medicinesData: patientData.medicinesData,
                complaints: patientData.complaints,
                diagnosis: patientData.diagnosis,
                advicesData: patientData.advicesData,
                clinicalFindingsData: patientData.clinicalFindingsData,
                PastHistoryData: patientData.PastHistoryData,
                isSpeechToTextEnabled: patientData.isSpeechToTextEnabled
            });

            console.log('🔥 Debug - Text Inputs Data:', textInputsData);
            console.log('🔥 Debug - Clinical Findings from patientData:', patientData.clinicalFindingsData);
            console.log('🔥 Debug - Clinical Findings from textInputsData:', textInputsData.clinical_findings);

            // Prepare consultation data for prescription creation
            const rawConsultationData = {
                patient_id: patient.patient_id || patient.id,
                patient_name: patient.name,
                patient_gender: patient.gender,
                patient_age: patient.age,
                patient_phone: patient.phone_no || patient.mobile_no || patient.phone || patient.phoneNumber,
                appointment_id: patient.appointment_id,
                timestamp: new Date().toISOString(),
                complaints: patientData.complaints || textInputsData.complaints || [],
                diagnosis: patientData.diagnosis || textInputsData.diagnosis || [],
                clinical_findings: patientData.clinicalFindingsData || textInputsData.clinical_findings || [],
                clinicalFindingsData: patientData.clinicalFindingsData || textInputsData.clinical_findings || [],
                PastHistoryData: patientData.PastHistoryData || textInputsData.PastHistory || [],
                medicinesData: patientData.medicinesData || [],
                advicesData: patientData.advicesData || textInputsData.advice || [],
                allergies: {
                    medicines: patientData.medicines || textInputsData.medicines || [],
                    food: patientData.food || textInputsData.food || [],
                    others: patientData.other || textInputsData.other || []
                },
                followUpDate: patientData.nextVisitDate || patientData.followUpDate,
                // parameters: consultationparametersData,
                investigationsList: patientData.investigationsList || [],
                pastMedication: patientData.pastMedication || "",
                referredDoctor: patientData.referredDoctor || "",
                referredSpeciality: patientData.referredSpeciality || "",
                referredPhone: patientData.referredPhone || "",
                referredEmail: patientData.referredEmail || "",
                referredHospital: patientData.referredHospital || "",
                referredHospitalAddress: patientData.referredHospitalAddress || ""
            };

            console.log('🔥 Debug - Raw Consultation Data:', rawConsultationData);

            // Prepare and validate consultation data
            const consultationData = prepareConsultationData(rawConsultationData);

            // Store consultation data in localStorage for prescription preview
            localStorage.setItem('currentConsultationData', JSON.stringify(consultationData));

            console.log('🔥 Starting prescription creation for appointment:', patient.appointment_id);

            // Create prescription using the service
            await handlePrescriptionCreation(
                consultationData,
                (result) => {
                    console.log('🔥 Prescription created successfully:', result);
                    patientActions.toast({
                        title: "Prescription Created",
                        description: "Prescription has been created successfully",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                },

                (error) => {
                    console.error('🔥 Prescription creation failed:', error);
                    patientActions.toast({
                        title: "Prescription Error",
                        description: `Failed to create prescription: ${error.message}`,
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            );


            // Close modal and open preview WITH DATA
            patientData.setIsEndConsultationModalOpen(false);
            patientData.setPrescriptionData(consultationData); // Store prescription data
            patientActions.onOpenPreviewModal(consultationData);
            // Update appointment status
            // await patientActions.updateAppointmentStatus();

        } catch (error) {
            console.error("Error ending consultation:", error);
            patientActions.toast({
                title: "Error",
                description: "Failed to end consultation. Please try again.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <>
            {/* End Consultation Modal */}
            <Modal
                isOpen={patientData.isEndConsultationModalOpen}
                onClose={() => patientData.setIsEndConsultationModalOpen(false)}
            >
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>End Consultation</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Text>Are you sure you want to end this consultation?</Text>
                        <Text mt={2}>This will:</Text>
                        <ul style={{marginLeft: "20px", marginTop: "10px"}}>
                            <li>Create prescription with all consultation data</li>
                            <li>Save all consultation data</li>
                            <li>Mark the appointment as completed</li>
                            <li>Show the preview page</li>
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="gray"
                            mr={3}
                            onClick={() => patientData.setIsEndConsultationModalOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={handleConfirmEndConsultation}
                        >
                            End Consultation
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Online Consultation Modal */}
            <Modal
                isOpen={patientData.isModalOpen}
                onClose={() => patientData.setIsModalOpen(false)}
            >
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>Online Consultation</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Box>
                            <Text mb="1">Consultation Type:</Text>
                            <Flex alignItems="center" mb="4">
                                <input
                                    type="checkbox"
                                    id="firstConsultation"
                                    checked={patientData.consultationType.firstConsultation}
                                    onChange={() => patientActions.handleConsultationTypeChange("firstConsultation")}
                                    style={{marginRight: "5px"}}
                                />
                                <label htmlFor="firstConsultation">First Consultation</label>
                            </Flex>
                            <Flex alignItems="center" mb="4">
                                <input
                                    type="checkbox"
                                    id="followUp"
                                    checked={patientData.consultationType.followUp}
                                    onChange={() => patientActions.handleConsultationTypeChange("followUp")}
                                    style={{marginRight: "5px"}}
                                />
                                <label htmlFor="followUp">Follow-Up</label>
                            </Flex>
                            <Box mb="4">
                                <Text>Amount:</Text>
                                <Input
                                    type="number"
                                    placeholder="Enter amount"
                                    value={patientData.amount}
                                    onChange={(e) => patientData.setAmount(e.target.value)}
                                />
                            </Box>
                            <Box mb="4">
                                <Text>Payment Mode:</Text>
                                <Select
                                    placeholder="Select payment mode"
                                    value={patientData.paymentMode}
                                    onChange={(e) => patientData.setPaymentMode(e.target.value)}
                                >
                                    <option value="creditCard">Credit Card</option>
                                    <option value="debitCard">Debit Card</option>
                                    <option value="paypal">PayPal</option>
                                </Select>
                            </Box>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="blue"
                            onClick={patientActions.handleOnlineConsultation}
                        >
                            Online Consultation
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Preview/Print Modal */}
            {/* <PreviewPrintPage
        isOpen={patientData.isPreviewOpen}
        onClose={patientActions.onClosePreviewModal}
        patientData={patient}
        doctor={patientData.doctor}
        parametersData={patientData.prescriptionData?.parameters || {}}
        allergiesData={patientData.allergiesData}
        complaints={patientData.complaints}
        diagnosis={patientData.diagnosis}
        medicinesData={patientData.medicinesData}
        advicesData={patientData.advicesData}
        followUpDate={patientData.followUpDate}
        selectedLanguage={patientData.selectedLanguage}
        prescriptionData={patientData.prescriptionData}
      /> */}
            <PreviewPageWYSIWYG
                isOpen={patientData.isPreviewOpen}
                onClose={patientActions.onClosePreviewModal}
                updateAppointmentStatus={patientActions.updateAppointmentStatus}
                patientData={patient}
                doctor={doctor}
                parametersData={patientData.prescriptionData?.parameters || {}}
                allergiesData={patientData.allergiesData}
                complaints={patientData.complaints}
                diagnosis={patientData.diagnosis}
                medicinesData={patientData.medicinesData}
                advicesData={patientData.advicesData}
                followUpDate={patientData.followUpDate}
                selectedLanguage={patientData.selectedLanguage}
                prescriptionData={patientData.prescriptionData}
                onPrescpSaved={(saved) => {
                    if (saved) {
                        patientActions.onClosePreviewModal();
                        onBack()
                    }

                }}
            />

        </>
    );
};

export default ConsultationModals;